import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZendeskComponent } from './components/icon/zendesk.component';
import { ZendeskRunService } from './run/zendesk.run.service';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonEventTriggerModule } from '@monsido/angular-shared-components';

export function initializeZendesk (zendeskRunService: ZendeskRunService): () => Promise<void> {
    return () => Promise.resolve().then(() => {
        zendeskRunService.setupEventListeners();
        return;
    });
}

@NgModule({
    declarations: [
        ZendeskComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        MonEventTriggerModule,
    ],
    exports: [
        ZendeskComponent,
    ],
    providers: [
        ZendeskRunService,
        provideAppInitializer(() => {
            const initializerFn = (initializeZendesk)(inject(ZendeskRunService));
            return initializerFn();
        }),
    ],
})
export class ZendeskModule { }
